var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("g",null,React.createElement("path",{"d":"M8.901 16.665H.92c-.508 0-.92-.412-.92-.92V.92C0 .412.412 0 .92 0h14.825c.508 0 .92.412.92.92v14.825c0 .508-.412.92-.92.92h-4.247V10.21h2.167l.324-2.515h-2.49V6.09c0-.728.202-1.224 1.246-1.224h1.332v-2.25c-.23-.03-1.021-.1-1.941-.1-1.92 0-3.235 1.173-3.235 3.325v1.855H6.73v2.515h2.172v6.454z","transform":"translate(-1072 -2021) translate(1038 2021.444) translate(34.37)"})))));
}

Facebook.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Facebook;

Facebook.default = Facebook;
